//#region Imports

import React, { Fragment } from 'react'

// icons
import {
    faCashRegister,
    faListAlt,
    faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// component
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// route
import { useLocation, withRouter } from 'react-router-dom'

// css
import './Venta.css'

import ItemVenta from './ItemVenta'


// functions
import { determinarTipoComprobante } from './Helpers'

// modals
import AdminVerifyModal from './AdminVerifyModal'
import ModalArticulosVenta from './ArticuloModalVentas/ModalArticuloVenta'
import ClientesModalVenta from './ClienteModalVentas/ClientesModalVenta'
import FinalizarVentaModal from './FinalizarModalVentas/FinalizarVentaModal'
import useCargarPresupuesto from './hooks/useCargarPresupuesto'
import useVenta from './hooks/useVenta'

//#endregion
function ConsolaVenta({ history }) {
    const {
        total, cliente, setListaPrecio, setTipoComprobante, setCliente, tipoComprobante,
        numeroComprobante, fecha, items, listasPrecios, tiposComprobantes,
        itemsFactura, subtotal, descuento, isLoad, show, handleShow, handleClose,
        setCodigoAndCantidad, codigoAndCantidad, inputTotalRef, deleteItem,
        reset, resetCompleto, createPresupuesto, handleKeyPress, listaPrecio,
        agregarItemManualmente, presupuestoId, setPresupuestoId, showAdminModal, setShowAdminModal, pendingAction,
        setPendingAction
    } = useVenta(history)

    const location = useLocation()
    const presupuesto = location.state?.item

    // Cargar presupuesto si viene de la pantalla de presupuestos
    useCargarPresupuesto(
        presupuesto,
        setPresupuestoId,
        setCliente,
        reset,
        agregarItemManualmente,
        history
    )



    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCashRegister} title={'Venta'} />
                </div>

                <div className="bg-gris centrado">
                    <div className="screen">
                        <p>SUBTOTAL: ${total.toFixed(2)}</p>
                    </div>

                    <div>
                        {/* BUSQUEDA DE CLIENTES, TIPO COMPROBANTE, NRO COMPROBANTE, FECHA */}
                        <div className="d-flex bd-highlight">
                            <div className="p-2 bd-highlight">
                                <label htmlFor="inputNumero">Cliente</label>
                                <div className="input-group-prepend">
                                    <input
                                        type="text"
                                        id="inputNombreCliente"
                                        name="nombre"
                                        className="form-control"
                                        defaultValue={cliente.id.persona.dni}
                                        disabled
                                        placeholder="Ingrese cliente"
                                    />
                                    <ClientesModalVenta
                                        setListaPrecio={setListaPrecio}
                                        setTipoComprobante={setTipoComprobante}
                                        setCliente={setCliente}
                                        determinarTipoComprobante={
                                            determinarTipoComprobante
                                        }
                                    />
                                </div>
                            </div>
                            <div className="p-2 bd-highlight"></div>
                            <div className="p-2 bd-highlight">
                                <label htmlFor="inputComprobante">
                                    Tipo Comprobante
                                </label>
                                <select
                                    id="inputComprobante"
                                    className="custom-select"
                                    name="comprobante"
                                    value={tipoComprobante}
                                    onChange={(e) =>
                                        setTipoComprobante(e.target.value)
                                    }
                                >
                                    {tiposComprobantes.map((comprobante) => (
                                        <option
                                            key={comprobante.id}
                                            value={comprobante.id}
                                        >
                                            {comprobante.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="p-2 bd-highlight">
                                <label htmlFor="inputNroComprobante">
                                    Nro Comprobante
                                </label>
                                <div className="input-group-prepend">
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="inputNroComprobante"
                                        value={numeroComprobante}
                                        disabled
                                        name="numeroComprobante"
                                    />
                                </div>
                            </div>
                            <div className="p-2 bd-highlight">
                                <label htmlFor="inputFecha">Fecha</label>
                                <div className="input-group-prepend">
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="inputFecha"
                                        value={fecha}
                                        disabled
                                        name="fecha"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* BUSQUEDA DE ARTICULO, INGRESO CODIGO, LISTA DE PRECIOS */}
                        <div className="d-flex bd-highlight">
                            <div className="p-2 bd-highlight">
                                <ModalArticulosVenta
                                    setCodigoAndCantidad={setCodigoAndCantidad}
                                    inputTotalRef={inputTotalRef}
                                    listaPrecio={listaPrecio}
                                />
                            </div>
                            <div className="p-2 flex-grow-1 bd-highlight">
                                <input
                                    className="form-control form-control-lg"
                                    style={{ height: 45 }}
                                    type="text"
                                    placeholder="Ingrese un articulo"
                                    value={codigoAndCantidad}
                                    ref={inputTotalRef}
                                    id="inputArticulo"
                                    onChange={(e) =>
                                        setCodigoAndCantidad(e.target.value)
                                    }
                                    onKeyPress={(e) => handleKeyPress(e)}
                                />
                            </div>
                            <div className="p-2 flex-grow-1 bd-highlight">
                                <select
                                    id="inputListaPrecio"
                                    className="custom-select"
                                    name="listaPrecio"
                                    style={{ height: 45 }}
                                    value={listaPrecio}
                                    onChange={(e) =>
                                        setListaPrecio(e.target.value)
                                    }
                                >
                                    {listasPrecios.map((lp, index) => (
                                        <option key={index} value={lp.id}>
                                            {lp.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* TABLA DE ARTICULOS INGRESADOS */}
                        <div className="table-wrapper">
                            <table className="table table-hover">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">Código</th>
                                        <th scope="col">Artículo</th>
                                        <th scope="col">Cantidad</th>
                                        <th scope="col">Precio</th>
                                        <th scope="col">Total</th>
                                        <th scope="col">IVA</th>
                                        <th scope="col">Descuento</th>
                                        <th scope="col">Eliminar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items
                                        ? items.map((item, index) => (
                                            <ItemVenta
                                                key={parseInt(index)}
                                                index={index}
                                                articulo={item}
                                                borrar={deleteItem}
                                            />
                                        ))
                                        : null}
                                </tbody>
                            </table>
                        </div>

                        {/* SUBTOTAL, DESCUENTO, TOTAL */}
                        <table className="table centrado">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">SUBTOTAL</th>
                                    <th scope="col">DESCUENTO</th>
                                    <th scope="col">TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>${subtotal.toFixed(2)}</td>
                                    <td>${descuento.toFixed(2)}</td>
                                    <td>${total.toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* BOTONES CANCELAR, PRESUPUESTO Y COBRAR */}
                        <div className="row justify-content-center">
                            <button
                                className="btn btn-outline-primary btn-lg col mr-1 ml-1"
                                onClick={() => resetCompleto()} // Usar resetCompleto
                            >
                                Cancelar Venta{' '}
                                <FontAwesomeIcon icon={faTimesCircle} />
                            </button>
                            <button
                                className="btn btn-outline-warning btn-lg col mr-1 ml-1"
                                onClick={() => createPresupuesto()}
                            >
                                Crear Presupuesto{' '}
                                <FontAwesomeIcon icon={faListAlt} />
                            </button>

                            <FinalizarVentaModal
                                ventaDatos={{
                                    total,
                                    subtotal,
                                    descuento,
                                    numeroComprobante,
                                    tipoComprobante,
                                    cliente,
                                    itemsFactura,
                                    presupuestoId: presupuestoId // Usar el estado directamente
                                }}
                                isLoad={isLoad}
                                show={show}
                                handleShow={handleShow}
                                handleClose={handleClose}
                                reset={resetCompleto} // Usar resetCompleto
                            />
                        </div>
                    </div>
                </div>
            </div>
            <AdminVerifyModal
                show={showAdminModal}
                onClose={() => setShowAdminModal(false)}
                onSuccess={() => {
                    if (pendingAction) {
                        pendingAction();
                        setPendingAction(null);
                    }
                }}
            />
        </Fragment>
    )
}

export default withRouter(ConsolaVenta)
